import { useAuth0 } from "@auth0/auth0-react";
import invariant from "@lib/utils/invariant";
import { useCallback } from "react";

/**
 * Returns a stable getter for the current user's access token, for the API client and the
 * WebSockets. Auth0 resolves to no token once the session has reached its maximum lifetime; the
 * getter throws in that case so every consumer takes its existing auth-error path instead of
 * sending a request with a `Bearer undefined` header.
 */
export function useAccessTokenProvider(): () => Promise<string> {
  const { getAccessTokenSilently } = useAuth0();
  return useCallback(async () => {
    const token = await getAccessTokenSilently();
    invariant(token, "Auth0 session expired: no access token available");
    return token;
  }, [getAccessTokenSilently]);
}
